import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../../data/content";

export const Navbar = ({ t, lang, setLang }) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => (e) => {
    e.preventDefault();
    window.__lenis?.scrollTo(id, { offset: -72, duration: 1.4 });
  };

  const links = [
    ["#chi-sono", t.nav.about],
    ["#trattamenti", t.nav.services],
    ["#studi", t.nav.studios],
    ["#faq", t.nav.faq],
  ];

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#FAF9F5]/85 backdrop-blur-xl shadow-[0_1px_0_rgba(77,99,84,0.12)]"
          : "bg-[#FAF9F5]/60 backdrop-blur-md"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 sm:px-8">
        <a href="#top" onClick={go("#top")} className="flex items-center gap-3" data-testid="nav-logo">
          <Logo size={38} />
          <span className="font-display text-lg italic leading-tight text-[#1E2721] sm:text-xl">
            Claudia D'Elia
            <span className="block font-body text-[10px] font-semibold uppercase not-italic tracking-[0.22em] text-[#556B5C]">
              Osteopata D.O.
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 lg:flex">
          {links.map(([href, label]) => (
            <a
              key={href}
              href={href}
              onClick={go(href)}
              className="link-underline text-sm font-medium text-[#38443B]"
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex overflow-hidden rounded-full border border-[#4D6354]/25 text-xs font-semibold">
            <button
              data-testid="language-toggle-it"
              onClick={() => setLang("it")}
              className={`px-3 py-1.5 transition-colors duration-300 ${
                lang === "it" ? "bg-[#4D6354] text-[#FAF9F5]" : "text-[#4D6354] hover:bg-[#E2EBE5]"
              }`}
            >
              IT
            </button>
            <button
              data-testid="language-toggle-en"
              onClick={() => setLang("en")}
              className={`px-3 py-1.5 transition-colors duration-300 ${
                lang === "en" ? "bg-[#4D6354] text-[#FAF9F5]" : "text-[#4D6354] hover:bg-[#E2EBE5]"
              }`}
            >
              EN
            </button>
          </div>
          <a
            href={`tel:+39${CONTACT.phoneTorino}`}
            data-testid="nav-phone-pill"
            className="hidden items-center gap-2 rounded-full bg-[#4D6354] px-4 py-2 text-sm font-semibold text-[#FAF9F5] transition-all duration-300 hover:bg-[#3E5244] hover:shadow-lg sm:flex"
          >
            <Phone size={14} />
            {CONTACT.phoneTorinoLabel}
          </a>
        </div>
      </div>
    </motion.header>
  );
};
